import * as React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/organisms/layout'
import Seo from '../components/molecules/seo'
import Posts from '../components/molecules/posts'
import Pagination from '../components/molecules/pagination'

const Index = props => {
  const siteTitle = props.data.site.siteMetadata?.title || `Title`
  const seoTitle = 'オッパイ星人の管理人がチン先に響く作品や女優を紹介するブログ'
  const posts = props.data.posts.edges

  return (
    <Layout location={props.location} title={siteTitle} >
      <Seo title={seoTitle} />
      <Posts posts={posts} />
      <Pagination props={props} />
    </Layout>
  )
}

export default Index

export const pageQuery = graphql`
  query ($skip: Int!) {
    site {
      siteMetadata {
        title
      }
    }
    posts: allMarkdownRemark(
      sort: {frontmatter: {date: DESC}}
      skip: $skip
      limit: 14
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "YYYY-MM-DD")
            update(formatString: "YYYY-MM-DD")
            title
            description
            category
            tags
            thumbnail {
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
          }
        }
      }
    }
    tags:allMarkdownRemark(limit: 2000) {
      group(field: {frontmatter: {tags: SELECT}}) {
        fieldValue
        totalCount
      }
    }
  }
`